export const ACTION_PERMISSION_STATUS_OPTIONS = [
  { key: 'Waiting', value: 'actionPermissions.statuses.Waiting' },
  { key: 'Approve', value: 'actionPermissions.statuses.Approve' },
  { key: 'Used', value: 'actionPermissions.statuses.Used' },
  { key: 'Rejected', value: 'actionPermissions.statuses.Rejected' },
  { key: 'Cancelled', value: 'actionPermissions.statuses.Cancelled' },
  { key: 'Expired', value: 'actionPermissions.statuses.Expired' },
];

export const EDITABLE_ACTION_PERMISSION_STATUS_OPTIONS = [
  { key: 'Waiting', value: 'actionPermissions.statuses.Waiting' },
  { key: 'Approve', value: 'actionPermissions.statuses.Approve' },
  { key: 'Used', value: 'actionPermissions.statuses.Used' },
  { key: 'Cancelled', value: 'actionPermissions.statuses.Cancelled' },
];
